import React, { useEffect, useState } from "react";
import httpRequest from "../../../utils/Http";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MyDataTable from "../../../component/MyDataTable";
import Switch from "../../../component/Switch";
import { ONLY_RM_ASM_ACTION_PERMISSION } from "../../../constant/action_permission";

const AddUpdateSubOffice = ({ sfdetails, roleId }) => {
  const [isSubmit, setSubmit] = useState(false);
  const [formData, setFormData] = useState({ sf_id: sfdetails.id });
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isOpenAddForm, setOpenAddForm] = useState(false);
  const [reloadList, setReload] = useState(true);

  useEffect(() => {
    (async () => {
      const state = await httpRequest("getallstatelist", {}, "GET");
      if (state.status === true && state.message) {
        setStateList(state.message);
      } else {
        setStateList([]);
      }
    })();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (formData.state_id) {
      (async () => {
        const city = await httpRequest(
          `getallcityfromstate?state_id=${formData.state_id}`,
          {},
          "GET",
        );
        if (city.status === true && city.message) {
          setCityList(city.message);
          if (!city.message.some((option) => option.value === formData.city)) {
            setFormData((prev) => ({ ...prev, city: null }));
          }
        } else {
          setFormData((prev) => ({ ...prev, city: null }));
          setCityList([]);
        }
      })();
    } else {
      setCityList([]);
      setFormData((prev) => ({ ...prev, city: null }));
    }
    //eslint-disable-next-line
  }, [formData.state_id]);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setSubmit(false);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  const validateFrom = (value) => {
    const errors = {};
    const requiredFields = [
      { field: "state_id", message: "State is required" },
      { field: "city", message: "City is required" },
      { field: "pincode", message: "Pincode is required" },
      { field: "rate", message: "Rate is required" },
      { field: "municipal_limit", message: "Municipal limit is required" },
    ];

    requiredFields.forEach(({ field, message }) => {
      if (!value[field]) {
        errors[field] = message;
      }
    });

    const pincode = value.pincode ? value.pincode.toString().trim() : "";
    if (pincode && pincode.length !== 6) {
      errors.pincode = "Enter valid pincode";
    }

    if (
      value.municipal_limit !== "" &&
      value.municipal_limit !== null &&
      Number(value.municipal_limit) < 0
    ) {
      errors.municipal_limit = "Municipal limit cannot be negative";
    }

    return errors;
  };

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        const data = await httpRequest("addupdatesuboffice", formData, "POST");

        setSubmit(false);
        if (data.status === true && data.message) {
          setFormData({ sf_id: sfdetails.id });
          setReload(true);
          setOpenAddForm(false);
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      }
    })();
    //eslint-disable-next-line
  }, [isSubmit, formErrors]);

  const updateToggleHandler = async (id, value) => {
    try {
      setReload(false);
      let postData = {
        id,
        is_active: value === true ? 1 : 0,
      };
      const data = await httpRequest("updatesfsubstatus", postData, "POST");

      if (data.status === true && data.message) {
        setReload(true);
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {}
  };

  const columns = [
    {
      name: "SNo.",
      selector: (row, index) => index + 1,
    },
    {
      name: "State",
      selector: (row) => row?.state?.state,
    },
    {
      name: "City",
      selector: (row) => row.city,
    },
    {
      name: "Pincode",
      selector: (row) => row.pincode,
    },
    {
      name: "Municipal Limit",
      selector: (row) => row.municipal_limit,
    },
    {
      name: "Rate",
      selector: (row) => `${row.rate} /KM`,
    },
    ONLY_RM_ASM_ACTION_PERMISSION.includes(roleId) && {
      name: "Status",
      selector: (row) =>
        Number(row.active) === 1 ? "Activated" : "DeActivated",
      cell: (row) => (
        <Switch
          isOn={Number(row.is_active) === 1 ? true : false}
          id={row.id}
          handleToggle={(e) => {
            updateToggleHandler(row.id, e.target.checked);
          }}
          onColor="#EF476F"
        />
      ),
    },
    {
      name: "Create Date",
      selector: (row) => new Date(row.createdAt).toDateString(),
    },
    ONLY_RM_ASM_ACTION_PERMISSION.includes(roleId) && {
      name: "Update",
      cell: (row) => (
        <button
          type="button"
          className="btn btn-sm btn-primary sub-office-table-action"
          title="Edit"
          onClick={() => {
            setFormData({
              sf_id: sfdetails.id,
              id: row.id,
              state_id: row.state_id,
              city: row.city,
              pincode: row.pincode,
              rate: row.rate,
              municipal_limit: row.municipal_limit,
            });
            setOpenAddForm(true);
          }}
        >
          <i className="fas fa-edit"></i>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
  ].filter(Boolean);

  return (
    <div className="sub-office-page">
      <section
        className={`content sub-office-form-section ${isOpenAddForm ? "" : "hide_display"}`}
      >
        <div className="container-fluid">
          <div className="card card-default sub-office-panel">
            <div className="card-header sub-office-header">
              <div className="sub-office-header-copy">
                <h3 className="card-title">Add Sub District Office</h3>
                <p className="sub-office-header-text">
                  Create a coverage zone for this service center.
                </p>
              </div>
              <button
                type="button"
                className="btn btn-sm btn-light sub-office-close-btn"
                onClick={() => {
                  setOpenAddForm(false);
                  setFormData({ sf_id: sfdetails.id });
                }}
              >
                <i className="fas fa-minus"></i>
              </button>
            </div>

            <form
              id="addsubform"
              className="sub-office-form"
              onSubmit={onSubmitHandler}
            >
              <div className="card-body sub-office-form-body">
                <div className="row sub-office-grid">
                  <div className="col-md-3 col-sm-6 sub-office-field">
                    <label>
                      State <span className="required-mark">*</span>
                      {formErrors.state_id && (
                        <span className="booking-action-error">
                          {formErrors.state_id}
                        </span>
                      )}
                    </label>
                    <Select
                      className="select2-purple sub-office-select"
                      classNamePrefix="select"
                      name="state_id"
                      value={
                        stateList.find(
                          (option) => option.value === formData.state_id,
                        ) || null
                      }
                      options={stateList}
                      onChange={(val) => {
                        setFormData({
                          ...formData,
                          state_id: val ? val.value : null,
                          city: null,
                        });
                      }}
                      placeholder="Select state"
                    />
                  </div>

                  <div className="col-md-3 col-sm-6 sub-office-field">
                    <label>
                      City <span className="required-mark">*</span>
                      {formErrors.city && (
                        <span className="booking-action-error">
                          {formErrors.city}
                        </span>
                      )}
                    </label>
                    <Select
                      className="select2-purple sub-office-select"
                      classNamePrefix="select"
                      name="city"
                      value={
                        cityList.find(
                          (option) => option.value === formData.city,
                        ) || null
                      }
                      options={cityList}
                      onChange={(val) => {
                        setFormData({
                          ...formData,
                          city: val ? val.value : null,
                        });
                      }}
                      placeholder="Select city"
                      isDisabled={!formData.state_id}
                    />
                  </div>

                  <div className="col-md-2 col-sm-6 sub-office-field">
                    <label>
                      Pincode <span className="required-mark">*</span>
                      {formErrors.pincode && (
                        <span className="booking-action-error">
                          {formErrors.pincode}
                        </span>
                      )}
                    </label>
                    <input
                      name="pincode"
                      id="pincode"
                      type="number"
                      placeholder="Enter pincode"
                      className="form-control sub-office-input"
                      value={formData.pincode || ""}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          pincode: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div className="col-md-2 col-sm-6 sub-office-field">
                    <label>
                      Municipal Limit <span className="required-mark">*</span>
                      {formErrors.municipal_limit && (
                        <span className="booking-action-error">
                          {formErrors.municipal_limit}
                        </span>
                      )}
                    </label>
                    <input
                      name="municipal_limit"
                      id="municipal_limit"
                      type="number"
                      min="0"
                      placeholder="0"
                      className="form-control sub-office-input"
                      value={formData.municipal_limit || ""}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          municipal_limit: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div className="col-md-2 col-sm-6 sub-office-field">
                    <label>
                      Rate <span className="required-mark">*</span>
                      {formErrors.rate && (
                        <span className="booking-action-error">
                          {formErrors.rate}
                        </span>
                      )}
                    </label>
                    <input
                      name="rate"
                      id="rate"
                      type="number"
                      step="0.01"
                      min="0"
                      placeholder="0.00"
                      className="form-control sub-office-input"
                      value={formData.rate || ""}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          rate: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div className="col-md-12 sub-office-action-field">
                    <button
                      type="submit"
                      className="btn btn-primary sub-office-submit-btn"
                    >
                      {formData.id ? "Update Office" : "Save Office"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      <section className="content sub-office-list-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="card sub-office-panel sub-office-list-panel">
                <div className="card-header sub-office-header">
                  <div className="sub-office-header-copy">
                    <h3 className="card-title">Sub District Office List</h3>
                    <p className="sub-office-header-text">
                      Service locations created for this center.
                    </p>
                  </div>
                  {ONLY_RM_ASM_ACTION_PERMISSION.includes(roleId) && (
                    <button
                      type="button"
                      className="btn btn-sm sub-office-add-btn"
                      onClick={() => {
                        setOpenAddForm(true);
                        setFormData({ sf_id: sfdetails.id });
                      }}
                    >
                      Add Office
                    </button>
                  )}
                </div>
                <div className="card-body sub-office-list-body">
                  <MyDataTable
                    reloadList={reloadList}
                    columns={columns}
                    getDataListURL={`getsfsuboffice?sf_id=${sfdetails.id}`}
                    setReload={setReload}
                    exportName={"subofficelist"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddUpdateSubOffice;
